export default __webpack_public_path__ + "static/media/katika_K2.e1d64d7a.svg";